export default "__VITE_PUBLIC_ASSET__ff53e3f6__"